import {
    DEVICES_COMMON_SEARCH_DEVICES,
    DEVICES_COMMON_SEARCH_DEVICES_RESULT
} from 'Redux/actionTypes';


export const devicesCommonGetDevices = (devices) => ({
    type: DEVICES_COMMON_SEARCH_DEVICES,
    payload: { devices }
});

export const devicesCommonGetDevicesResult = (data, errors) => ({
    type: DEVICES_COMMON_SEARCH_DEVICES_RESULT,
    payload: { data, errors }
});